import en from 'element-ui/lib/locale/lang/en';

// 英语(美国)
export default {
  ...en,
  layout: {
    title: 'Sign In with Uniportal ID',
    tip: 'Unregistered mobile number will be automatically registered after successful login',
    line: 'Other Login Options',
  },
  button: {
    submit: 'Login / Register',
    getCode: 'Get code',
    emailRegister: 'Register by Email',
    w3Login: 'W3 Account Login',
    employeeLogin: 'Employee Login',
    passwordLogin: 'Password Login',
    reSend: 'Re-send',
    problem: 'Encountered a problem',
    privacyPolicy: 'Privacy Policy',
  },
  placeholder: {
    phoneNumber: 'Mobile number',
    verificationCode: 'SMS verification code',
  },
  dialog: {
    imgCode: 'Enter the characters on the image.',
    userAgreements: {
      header: 'User Agreement and Privacy Statement',
      text1: 'Please read and agree to the {privacy} and {agreement}.',
      text2:
        'When you access Huawei apps outside China, your personal information will be transferred to Huawei subsidiaries outside China for processing. For details, see {privacy}.',
    },
    crossBorder: {
      header: 'Authorization Tips',
      text: 'The local service you use is not in the same region as the place where your account is registered. If cross-border access to account information is involved, you must obtain your authorization.',
    },
    multiAccounts: 'Select an account.',
    agreeButton: 'Agree and Continue',
    disagreeButton: 'Disagree',
    confirmButton: 'Confirm',
    cancelButton: 'Cancel',
    knowMe: 'OK',
  },
  toast: {
    hasSend: 'Verification code sent.',
    wait: 'Please wait a moment.',
  },
  tooltip: {
    Huawei: 'Huawei ID',
    Tencent: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    Google: 'Google',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': 'The CAPTCHA code cannot be empty.',
    'IDC-03-0002': 'The CAPTCHA code has expired.',
    'IDC-00-0004': 'Incorrect CAPTCHA code.',

    // 表单输入为空
    'IDC-01-00024': 'The country code is required to verify your mobile number.',
    phoneNumberEmpty: 'Enter the mobile number.',
    'IDC-03-00033': 'Enter the SMS verification code.',

    // 表单数据错误
    'IDC-02-00227': 'The mobile number entered does not match the selected country/region.',
    'IDC-02-00226': 'The country code has been disabled',
    'IDC-02-00029': 'The verification code is incorrect or has expired.',
    'IDC-02-0013': 'Login failed due to incorrect SMS verification code.',
    'IDC-02-0020': 'Verification failed. Incorrect verification code.',
    'IDC-02-00028': 'The mobile number must contain 6 to 30 digits. ',
    'IDC-02-00012': 'Incorrect mobile number. ',

    // 错误操作锁定
    accountLock:
      'Incorrect mobile number or verification code. {number} attempt remaining. | Incorrect mobile number or verification code. {number} attempts remaining.',
    accountLocked:
      'Too many failed attempts. Please try again in {number} second. | Too many failed attempts. Please try again in {number} seconds.',
    operationRisk:
      'The current operation has security risks. Please try again in {number} seconds.',

    // 频繁操作
    'IDC-02-00038': 'Please try again after 60 seconds.',
    'IDC-02-00064':
      'You have sent SMS verification codes too frequently. Please try again 24 hours later.',
    'IDC-02-00211': 'The current operation has security risks. Please try again later.',
    'IDC-02-00212':
      'The number of SMS verification codes sent by your mobile number is too frequent. Please change your mobile number or try again 24 hours later.',
    'IDC-02-00213':
      'You have sent SMS verification codes too frequently. Please try again 24 hours later.',
    'IDC-02-00215':
      'The number of SMS verification codes sent by your mobile number is too frequent. Please change your mobile number, select another verification method, or try again 24 hours later.',
    'IDC-02-00228':
      'You have sent SMS verification codes too frequently. Please try again one hour later.',
    'IDC-02-00092': 'The current operation is too frequent. Please try again 24 hours later.',

    // 请求异常
    'IDC-10-00400': 'Abnormal client request.',
    'IDC-10-00500': 'Internal system error. ',
    'IDC-02-00264': 'Unauthorized requests for access are forbidden',
    'IDC-02-00063': 'Invalid parameter. ',
    'IDC-03-0007': 'This operation poses security risks, and account registration is not allowed.', // 机翻
    'IDC-03-00057': 'The current operation has security risks.',

    // 页面过期
    'IDC-00-00017': 'The page has expired.',
  },

  // 注册协议、隐私声明对话框
  backButton: 'Back',
  closeButton: 'Close',

  // 滑块验证相关：
  resourceReqFailed: 'Resource request failed. Refresh the page and try again.',
  verifyFailedAndPlsRetry: 'Verification failed. Please try again.',
  serviceErrAndPlsRetry: 'Service exception. Please try again.',
  learnMore: 'Learn more',
  cookieBannerText: 'This website uses cookies to provide you with the best user experience.',
};
